module.exports = __webpack_public_path__ + "img/icon-ios-add.7955d2fa.svg";